import { $config } from '@client/core/atoms/config.js';
import { isFeatureEnabled } from '@client/core/atoms/unleashFeatures.js';
import {
  FinnLegendaryVertical,
  UNLEASH_FEATURE_NAME,
  Vertical
} from '@schibsted-nmp/advertising-shared';

const mobilityVerticals: string[] = [
  Vertical.Mobility,
  FinnLegendaryVertical.Car,
  FinnLegendaryVertical.Boat,
  FinnLegendaryVertical.Mc,
  FinnLegendaryVertical.B2B,
  FinnLegendaryVertical.Atv,
  FinnLegendaryVertical.Scooter,
  FinnLegendaryVertical.Snowmobile
];

export const isMobilityPulseAdsEnabled = () => {
  const vertical = $config.get()?.vertical;
  return (
    vertical !== undefined &&
    mobilityVerticals.includes(vertical) &&
    isFeatureEnabled(UNLEASH_FEATURE_NAME.enablePulseEventsForAds)
  );
};
